import React from "react";

export default function Rewards(props) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="w-full max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-md p-6 mb-4">
          <h2 className="text-2xl font-bold mb-2">Your Points</h2>
          <div className="text-4xl font-bold text-green-500">
            {props.Points}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6 mb-4">
          <h2 className="text-2xl font-bold mb-4">Your Badges</h2>
          <div className="grid grid-cols-2 gap-4">
            {props.Points > 100 ? (
              <div className="flex items-center gap-2">
                <StarIcon className="h-6 w-6 text-yellow-500" />
                <div>
                  <h3 className="font-bold">Super Star</h3>
                  <p className="text-sm text-gray-500">
                    Earned by getting 100 points
                  </p>
                </div>
              </div>
            ) : (
              <noscript />
            )}
            {props.Points > 250 ? (
              <div className="flex items-center gap-2">
                <CheckIcon className="h-6 w-6 text-green-500" />
                <div>
                  <h3 className="font-bold">Achiever</h3>
                  <p className="text-sm text-gray-500">
                    Earned by getting 250 tasks
                  </p>
                </div>
              </div>
            ) : (
              <noscript />
            )}
            {props.Points > 500 ? (
              <div className="flex items-center gap-2">
                <FlameIcon className="h-6 w-6 text-red-500" />
                <div>
                  <h3 className="font-bold">Hot Streak</h3>
                  <p className="text-sm text-gray-500">
                    Earned by logging in 7 days in a row
                  </p>
                </div>
              </div>
            ) : (
              <noscript />
            )}
            {props.Points > 1000 ? (
              <div className="flex items-center gap-2">
                <ClockIcon className="h-6 w-6 text-blue-500" />
                <div>
                  <h3 className="font-bold">Early Bird</h3>
                  <p className="text-sm text-gray-500">
                    Earned by logging in before 6am
                  </p>
                </div>
              </div>
            ) : (
              <noscript />
            )}
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold mb-4">Redeem Points</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="border p-4 rounded-lg">
              <h3 className="font-bold mb-2">Free Coffee</h3>
              <p className="text-sm text-gray-500 mb-2">
                Redeem for a free coffee at any of our partner cafes.
              </p>
              <div className="text-green-500 font-bold">500 Points</div>
            </div>
            <div className="border p-4 rounded-lg">
              <h3 className="font-bold mb-2">Discount Code</h3>
              <p className="text-sm text-gray-500 mb-2">
                Redeem for a 10% discount at any of our partner stores.
              </p>
              <div className="text-green-500 font-bold">1000 Points</div>
            </div>
            <div className="border p-4 rounded-lg">
              <h3 className="font-bold mb-2">Free Course</h3>
              <p className="text-sm text-gray-500 mb-2">
                Redeem for a free course at any of our partner online learning
                platforms.
              </p>
              <div className="text-green-500 font-bold">2000 Points</div>
            </div>
            <div className="border p-4 rounded-lg">
              <h3 className="font-bold mb-2">Gift Card</h3>
              <p className="text-sm text-gray-500 mb-2">
                Redeem for a $20 gift card at any of our partner stores.
              </p>
              <div className="text-green-500 font-bold">2500 Points</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CheckIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function ClockIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  );
}

function FlameIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
    </svg>
  );
}

function StarIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  );
}
